import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Response = Api.Core.Claim.StatusFlow.IResponse;
type Headers = Api.Core.Claim.StatusFlow.IHeaders;
const url = '/api/Claims/Claim/StatusFlow';
export default async function claimStatusFlowApi(): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
